import React, { FormEvent, useRef, useState } from 'react';
import styled from 'styled-components';
import { Body, Headline } from '../../../shared/styled-components/styled_text';
import { IconInput } from '../../../shared/components/IconInput';
import { FilledButton, TextButton } from '../../../shared/styled-components/styled_buttons';
import { Form } from './styled';
import { postRequestPasswordReset } from '../../../common/api/apiClient';
import { FlexCol } from '../../../shared/FlexCol';
import { isValidId } from '../../../common/utils/useLoginController';

export const EditPassword: React.FC = () => {
  const [type, setType] = useState<'email' | 'phone'>('email');
  const [accountId, setAccountId] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const form = useRef<HTMLFormElement>(null);

  const handleIdChange = (v: string) => {
    setAccountId(v);

    if (v.trim().length === 0) {
      setErrorMessage(undefined);
      return;
    }

    if (type === 'email') {
      if (!isValidId(v)) {
        setErrorMessage('올바른 아이디(이메일)을 입력해주세요');
        return;
      }
    } else {
      const phoneRe = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/;
      if (!phoneRe.test(v)) {
        setErrorMessage('유효한 연락처를 입력해주세요');
        return;
      }
    }

    setErrorMessage(undefined);
  };

  const handleReset = async (e: FormEvent) => {
    e.preventDefault();
    try {
      await postRequestPasswordReset(type, accountId!);
      alert(
        `입력하신 ${
          type === 'email' ? '이메일' : '연락처'
        }로 비밀번호를 변경할 수 있는 링크가 전송되었어요. 1시간 안에 비밀번호 변경 후 로그인해주세요.`,
      );
    } catch {
      setErrorMessage(type === 'email' ? '가입되지 않은 이메일이에요' : '가입되지 않은 연락처입니다');
    }
  };

  return (
    <Container>
      <Form onSubmit={handleReset} ref={form}>
        <FlexCol align={'flex-start'} width={'100%'} gap={'0.2rem'}>
          <img src={'/images/common/lock_black.svg'} style={{ width: '3.2rem', height: '3.2rem' }} alt={'lock'} />
          <Headline size={'m'} style={{ marginTop: '0.2rem' }}>
            비밀번호를 모르시나요?
          </Headline>
          <Body size={'l'} style={{ color: 'var(--mono)' }}>
            새로운 비밀번호로 변경하실 수 있도록 <br />
            링크를 {type === 'email' ? '이메일' : '연락처'}로 보내드릴게요.
          </Body>
        </FlexCol>

        <FlexCol align={'flex-start'} width={'100%'} gap={'1.6rem'} style={{ marginTop: '1rem' }}>
          <IconInput
            label={`가입하신 ${type === 'email' ? '이메일 주소' : '연락처'}`}
            value={accountId}
            onChange={v => handleIdChange(v)}
            placeholder={type === 'email' ? '아이디(이메일)를 입력해주세요' : '010-0000-0000'}
            type={type === 'email' ? 'email' : 'tel'}
            errorMessage={errorMessage}
            autocomplete={true}
            required={true}
            containerStyle={{ width: '100%' }}
          />
          <FlexCol align={'flex-start'} width={'100%'} gap={'0.6rem'}>
            <FilledButton size={'m'} color={'primary'} style={{ width: '100%' }} disabled={accountId.trim().length === 0}>
              링크 보내기
            </FilledButton>
            <TextButton
              size={'xs'}
              color={'mono'}
              style={{ margin: '0.4rem auto 0' }}
              onClick={() => {
                setAccountId('');
                setErrorMessage(undefined);
                setType(prev => (prev === 'email' ? 'phone' : 'email'));
              }}
              type={'button'}
            >
              {type === 'email' ? '연락처' : '이메일'}로 가입했어요
            </TextButton>
          </FlexCol>
        </FlexCol>
      </Form>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
`;
